import { useEffect, useState } from 'react';
import { Admin, Resource } from 'react-admin';
import authProvider from './authProvider';
import { HubCallback } from './components/auth/HubCallback';
import { HubLoginPage } from './components/auth/HubLoginPage';
import Eligibility from './components/eligibility/Eligibility';
import { ReferralList } from './components/referrals/Referral';
import { CustomLayout } from './config/CustomLayout';
import { customRoutes } from './config/customRoutes';
import dataProvider from './dataProvider';
import featuresClient, { FeatureFlags, FeaturesName } from './lib/features';
import { AuthService } from './services/auth';
import { HUB_CALLBACK_PATH, isHubSignInEnabled } from './services/hubAuth';
import './styles/global.css';
import { theme } from './styles/theme';
import { Roles } from './util/constants';

const dataProviderLive = dataProvider();

const App = () => {
  const [shouldShow, setShouldShow] = useState<FeatureFlags>({
    patientLabResults: false,
    medicalSetup: false,
    patientConditions: false,
    auditLogs: false,
    communicationsCenter: false,
    documents: false,
    coupons: false,
    referralsCreation: false,
    referralsHub: false,
  });

  useEffect(() => {
    (async () => {
      const [
        patientLabResults,
        medicalSetup,
        patientConditions,
        auditLogs,
        communicationsCenter,
        documents,
        coupons,
        referralsCreation,
        referralsHub,
      ] = await featuresClient.fetchFeatureFlagsStatus([
        { name: FeaturesName.OpsDashShowPatientsLabResults },
        { name: FeaturesName.OpsDashShowMedicalSetup },
        { name: FeaturesName.OpsDashShowPatientConditions },
        { name: FeaturesName.OpsDashShowAuditLogs },
        { name: FeaturesName.OpsDashShowCommunicationsCenter },
        { name: FeaturesName.OpsDashShowDocuments },
        { name: FeaturesName.OpsDashShowCoupons },
        { name: FeaturesName.OpsDashShowReferralsCreation },
        { name: FeaturesName.OpsDashShowReferralsHub },
      ]);

      setShouldShow({
        patientLabResults,
        medicalSetup,
        patientConditions,
        auditLogs,
        communicationsCenter,
        documents,
        coupons,
        referralsCreation,
        referralsHub,
      });
    })();
  }, []);

  // The router is hash-based, so the Hub redirect lands on a real path outside react-admin
  if (isHubSignInEnabled() && window.location.pathname === HUB_CALLBACK_PATH) {
    return <HubCallback />;
  }

  return (
    <Admin
      {...(isHubSignInEnabled() && { loginPage: HubLoginPage })}
      authProvider={authProvider}
      customRoutes={customRoutes(shouldShow)}
      dataProvider={dataProviderLive}
      disableTelemetry
      layout={CustomLayout}
      theme={theme}>
      {() => [
        AuthService.checkRoleAccess(Roles.Billing) && [
          <Resource name='eligibility' list={Eligibility} />,
        ],
        AuthService.checkRoleAccess([Roles.Operations, Roles.TechSupport]) && [
          <Resource name='referrals' list={ReferralList} />,
        ],
      ]}
    </Admin>
  );
};

export default App;
